import { Component } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';
import { GetsuppressedEmailComponent } from "./getsuppressed-email/getsuppressed-email.component";
import { DeletesuppressedEmailComponent } from "./deletesuppressed-email/deletesuppressed-email.component";
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';

@Component({
  selector: 'app-suppressed-email-components',
  standalone: true,
  imports: [
    MatTabsModule,
    GetsuppressedEmailComponent,
    DeletesuppressedEmailComponent,
    CommonModule,
    PageHeaderComponent
],
  templateUrl: './suppressed-email-components.component.html',
  styleUrl: './suppressed-email-components.component.css'
})
export class SuppressedEmailComponentsComponent {
  activeTab = 'consult'

  setActiveTab(tab : string){
    this.activeTab = tab;
  }

}
